const actionTypes = { SET_NTH_CATEGORY: 'SET_NTH_CATEGORY' };

module.exports = actionTypes;
